export default __webpack_public_path__ + "static/media/stainless.7728f58e.jpg";